import { getDefaultPanelColors } from './get-default-panel-colors';

export function setDefaultPanelText(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.setProperty('--panelText', getDefaultPanelColors().panelText);
}
